import helper from '../helper'

export default {
  controller: '/entries',
  all (callback) {
    helper.getRequest(this.controller, false, callback)
  },
  delete (id, callback) {
    helper.deleteRequest(this.controller + '/' + id, true, callback)
  },
  update (entry, callback) {
    let data = new FormData()
    data.append('id', entry.id)
    data.append('title', entry.title)
    data.append('date', entry.date)
    data.append('text', entry.text)
    data.append('no_details', entry.noDetails)
    if (entry.categories) {
      entry.categories.forEach((cat) => {
        data.append('categories[]', cat.id)
      })
    }
    data.append('_method', 'PUT')
    helper.postRequest(this.controller + '/' + entry.id, true, data, callback)
  },
  add (entry, callback) {
    let data = new FormData()
    data.append('id', entry.id)
    data.append('title', entry.title)
    data.append('date', entry.date)
    data.append('text', entry.text)
    data.append('no_details', entry.noDetails)
    if (entry.categories) {
      entry.categories.forEach((cat) => {
        data.append('categories[]', cat.id)
      })
    }
    helper.postRequest(this.controller, true, data, callback)
  },
  addImage (entryId, files, callback) {
    let data = new FormData()
    for (let index = 0; index < files.length; index++) {
      data.append('img[]', files[index])
    }
    helper.postRequest(this.controller + '/img/' + entryId, true, data, callback)
  },
  removeImage (id, callback) {
    helper.deleteRequest(this.controller + '/img/' + id, true, callback)
  },
  saveImageMapping (smallImagesArray, mediumImagesArray, largeImagesArray, callback) {
    let smallImages = ''
    let mediumImages = ''
    let largeImages = ''
    smallImagesArray.forEach((img) => {
      smallImages = smallImages + img.id + ';'
    })
    mediumImagesArray.forEach((img) => {
      mediumImages = mediumImages + img.id + ';'
    })
    largeImagesArray.forEach((img) => {
      largeImages = largeImages + img.id + ';'
    })
    let body = {
      smallImages,
      mediumImages,
      largeImages
    }
    helper.postRequest(this.controller + '/saveImageMapping', true, body, callback)
  }
}



// WEBPACK FOOTER //
// ./src/services/rest/controllers/entries.js